import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsProtect4InV4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M34 0V30H64" stroke="#FFDD00" strokeWidth="2" />
      <path d="M30 33L30 63H0" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
